import { snackbar } from "@mobiscroll/react5";
import { getQuery, postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { CANCEL_APPOINTMENT } from "src/components/graphql/GraphQLmutation";
import { LIST_TODAY_APPOINTMENTS } from "src/components/graphql/GraphQLquery";

export async function listAppointments(take, start, end, filters) {
  try {
    const response = await getQuery(
      LIST_TODAY_APPOINTMENTS(take, start, end, filters)
    );
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch appointments");
    }

    const result = response?.data?.listAppointmentsDoctor;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch appointments");
    }
    
    // Success case
    if (result?.data) {
      console.log("List of Appointments fetched successfully.");
      return result;
    }
    return null;
  } catch (e) {
    // Silent error for appointments list - can show snackbar if needed
    // snackbar({
    //   message: e.message,
    //   color: "danger",
    // });
    console.error("Error at listAppointments:", e);
    return null;
  }
}

export async function cancelAppointment(data) {
  try {
    let response = await postMutation(CANCEL_APPOINTMENT, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to cancel appointment");
    }

    const result = response?.data?.cancelAppointment;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to cancel appointment");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Appointment cancelled successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at cancelAppointment:", e);
    return false;
  }
}
